import { useTranslations } from "next-intl";
import React, { useEffect, useRef, useState } from "react";
import { useSearchBox, UseSearchBoxProps } from "react-instantsearch";

import styles from "./custom-search-box.module.scss";

type Props = UseSearchBoxProps & {
  onChange?: (query: string) => void;
};

export default function CustomSearchBox(props: Props) {
  const t = useTranslations();
  const { onChange: _, ...useSearchBoxProps } = props;
  const { query, refine } = useSearchBox(useSearchBoxProps);
  const [inputValue, setInputValue] = useState(query);
  const inputRef = useRef<HTMLInputElement>(null);

  // query updated from outside (querystring)
  useEffect(() => {
    if (query != inputValue) {
      setInputValue(query);
    }
  }, [inputValue, query]);

  function setQuery(newQuery: string) {
    setInputValue(newQuery);

    refine(newQuery);
  }

  return (
    <form
      className={styles.form}
      action=""
      role="search"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();

        if (inputRef.current) {
          inputRef.current.blur();
        }
      }}
      onReset={(event) => {
        event.preventDefault();
        event.stopPropagation();

        setQuery("");

        if (inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <input
        className={styles.input}
        size={query.length > 0 ? query.length : 10}
        ref={inputRef}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        placeholder={t("generic.search_placeholder")}
        spellCheck={false}
        maxLength={512}
        type="search"
        value={inputValue}
        onChange={(event) => {
          const query = event.currentTarget.value;
          props.onChange?.(query);
          setQuery(query);
        }}
        autoFocus
      />
    </form>
  );
}
